import { ComboBox } from "~/components/form/combo-box/ComboBox";
import { formatInterval } from "~/util/qendo/schedule";

export type IntervalSelectorProps = {
    value?: number | null | undefined;
    onChange?: (interval: number) => void;
    disabled?: boolean;
};

const MAX_DAYS = 98;
const MIN_DAYS = 2;

const IntervalOptions = [...Array.from({ length: MAX_DAYS - MIN_DAYS }).keys()].map((item) => {
    const value = item + MIN_DAYS;

    return {
        value,
        label: formatInterval(value),
    };
});

export const IntervalSelector = ({ value, onChange, disabled }: IntervalSelectorProps) => {
    const interval = value ?? null;

    const setInterval = (val: number | null) => {
        onChange?.(Math.max(MIN_DAYS, Math.min(MAX_DAYS, val ?? MIN_DAYS)));
    };

    return (
        <ComboBox
            label="Interval"
            items={IntervalOptions}
            value={interval}
            onItemSelected={setInterval}
            disabled={disabled}
            searchable={false}
        />
    );
};
